if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.addToCartButton = this.productSection.querySelector('product-form button[name="add"]');
      this.handleScroll = this.handleScroll.bind(this);
      this.bindEvents();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }

    bindEvents() {
      if ('IntersectionObserver' in window && this.addToCartButton) {
        this.observer = new IntersectionObserver(this.handleScroll);
        this.observer.observe(this.addToCartButton);
      }

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);
      this.handleScroll();
    }

    handleScroll() {
      const buttonBounds = this.addToCartButton?.getBoundingClientRect();
      this.classList.toggle(
        'sticky-atc-panel--out',
        !buttonBounds || buttonBounds.height === 0 || buttonBounds.bottom > 0
      );
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
